export default function queryJson(query){
    return JSON.parse('{"' + decodeURI(query[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
}
